<template>
    <Modal2 v-if="visible" design="v3" class-name="bulk-owner-modal" :show-footer="false" :show-title="false"
        @cancel="onCancel">
        <div class="bulk-owner-modal-content">
            <div class="modal-section">
                <div class="info-banner">
                    <div class="banner-icon">
                        <i class="material-icons">info</i>
                    </div>
                    <div class="banner-content">
                        <div class="banner-title">Bilgilendirme</div>
                        <div class="banner-text">
                            Aşağıda gösterilen kullanıcılar, seçmiş olduğunuz kişilerin görebileceği kullanıcıların
                            kesişimi olarak alınmıştır.
                        </div>
                    </div>
                </div>

                <div class="selection-wrapper">
                    <div class="section-title">
                        <i class="material-icons">person_search</i>
                        <span>Sahip Kullanıcı Seçimi</span>
                    </div>

                    <div class="form-field" style="margin-bottom: 24px;">
                        <div style="display: flex; align-items: center; justify-content: space-between;">
                            <label class="field-label" style="margin-bottom: 0;">Sahipliği Kaldır</label>
                            <a-switch v-model="isRemoveOwner" />
                        </div>
                        <div class="field-hint">
                            <i class="material-icons">info_outline</i>
                            <span>Seçili kişilerin sahipliğini kaldırmak için işaretleyin</span>
                        </div>
                    </div>

                    <div class="form-field" :style="{ opacity: isRemoveOwner ? 0.5 : 1, pointerEvents: isRemoveOwner ? 'none' : 'auto' }">
                        <label class="field-label">Kullanıcı</label>
                        <a-select v-model="selectedOwner" size="large" placeholder="Sahip kullanıcı seçin..."
                            :filter-option="filterOption" show-search class="owner-select" :disabled="isRemoveOwner">
                            <a-select-option v-for="user in availableUsers" :key="user._id" :value="user._id">
                                {{ user.name || user.email }}
                            </a-select-option>
                        </a-select>
                        <div class="field-hint">
                            <i class="material-icons">lightbulb_outline</i>
                            <span>Sahiplik için tek bir kullanıcı seçebilirsiniz</span>
                        </div>
                    </div>
                </div>

                <div v-if="selectedOwner && !isRemoveOwner" class="preview-section">
                    <div class="preview-header">
                        <i class="material-icons">visibility</i>
                        <span>Seçilen Sahip</span>
                    </div>
                    <div class="owner-card">
                        <div class="owner-avatar">
                            <i class="material-icons">person</i>
                        </div>
                        <div class="owner-details">
                            <div class="owner-name">{{ getUserName(selectedOwner) }}</div>
                            <div class="owner-role">Sahip Kullanıcı</div>
                        </div>
                        <div class="owner-badge">
                            <i class="material-icons">verified</i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <SupsisButton @click="onCancel">İptal</SupsisButton>
                <SupsisButton primary @click="onConfirm">
                    <i class="material-icons">person_add</i>
                    Sahip Ata
                </SupsisButton>
            </div>
        </div>
    </Modal2>
</template>

<script>
import Modal2 from "@/components/common/Modal2.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
import { mapState } from "vuex";
import ChatWatcherV2 from "@/ChatWatcherV2.js";

export default {
    name: "BulkSetOwnerModal",
    components: { Modal2, SupsisButton },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        selectedCount: {
            type: Number,
            default: 0,
        },
        selectedContacts: {
            type: Array,
            default: () => [],
        },
    },
    data: function () {
        return {
            selectedOwner: null,
            isRemoveOwner: false,
        };
    },
    watch: {
        isRemoveOwner(val) {
            if (val) {
                this.selectedOwner = null;
            }
        }
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            channels: (state) => state.channel.channels,
            authUser: (state) => state.auth.user,
        }),
        availableUsers: function () {
            const activeUsers = this.users.filter((user) => !user.isDeleted);
            if (this.selectedContacts.length === 0) {
                return activeUsers;
            }

            const filteredUsers = activeUsers.filter((user) => {
                const accessibleChannels = ChatWatcherV2.listAvailableChannels(user).map((channel) => channel._id);
                const isUserRoot = user.role?.isRoot || false;
                if (isUserRoot) {
                    return true;
                }
                const userDepartments = user.subjects || [];
                const ownedChannels = this.channels
                    .filter((channel) => (channel?.visibility?.owners || []).includes(user._id))
                    .map((channel) => channel._id);
                const canOwnAll = this.selectedContacts.every((contact, index) => {
                    const isOwnedChannel = ownedChannels.includes(contact.channel);
                    if (isOwnedChannel) {
                        console.groupEnd();
                        return true;
                    }

                    const isChannelAccessible = accessibleChannels.includes(contact.channel);
                    const isDepartmentAccessible =
                        !(contact.relatedDepartments || []).length ||
                        (contact.relatedDepartments || []).some((deptId) =>
                            userDepartments.length === 0 || userDepartments.includes(deptId)
                        );
                    const result = isChannelAccessible && isDepartmentAccessible;
                    return result;
                });
                return canOwnAll;
            });
            return filteredUsers;
        },
    },
    methods: {
        getUserName: function (userId) {
            const user = this.users.find((u) => u._id === userId);
            return user ? user.name || user.email : userId;
        },
        filterOption: function (input, option) {
            const user = this.users.find((u) => u._id === option.key);
            if (!user) return false;
            const name = user.name || user.email || "";
            return name.toLowerCase().includes(input.toLowerCase());
        },
        onConfirm: function () {
            if (!this.selectedOwner && !this.isRemoveOwner) {
                this.$message.warning("Lütfen bir sahip kullanıcı seçiniz");
                return;
            }

            this.$emit("confirm", {
                action: "set-owner",
                payload: {
                    ownerId: this.isRemoveOwner ? null : this.selectedOwner,
                },
            });
            this.reset();
        },
        onCancel: function () {
            this.$emit("cancel");
            this.reset();
        },
        reset: function () {
            this.selectedOwner = null;
            this.isRemoveOwner = false;
        },
    },
};
</script>

<style lang="scss">
.bulk-owner-modal {
    .custom-modal-body {
        padding: 0 !important;
    }

    .bulk-owner-modal-content {
        display: flex;
        flex-direction: column;
        min-height: 450px;

        .modal-section {
            flex: 1;
            padding: 28px;
            overflow-y: auto;
        }

        .info-banner {
            display: flex;
            gap: 16px;
            padding: 18px 20px;
            background: linear-gradient(135deg, #e7f3ff 0%, #f0f8ff 100%);
            border-left: 4px solid #0066cc;
            border-radius: 10px;
            margin-bottom: 28px;

            .banner-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                height: 40px;
                background: #0066cc;
                border-radius: 10px;
                flex-shrink: 0;

                .material-icons {
                    font-size: 22px;
                    color: white;
                }
            }

            .banner-content {
                flex: 1;

                .banner-title {
                    font-size: 14px;
                    font-weight: 700;
                    color: #004080;
                    margin-bottom: 4px;
                    letter-spacing: 0.3px;
                }

                .banner-text {
                    font-size: 13px;
                    color: #004080;
                    line-height: 1.6;
                }
            }
        }

        .selection-wrapper {
            margin-bottom: 28px;

            .section-title {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 20px;
                padding-bottom: 12px;
                border-bottom: 2px solid #e8eaed;

                .material-icons {
                    font-size: 24px;
                    color: #22272d;
                }

                span {
                    font-size: 16px;
                    font-weight: 700;
                    color: #22272d;
                    letter-spacing: 0.3px;
                }
            }

            .form-field {
                .field-label {
                    display: block;
                    font-size: 14px;
                    font-weight: 600;
                    color: #495057;
                    margin-bottom: 10px;
                    letter-spacing: 0.3px;
                }

                .owner-select {
                    width: 100%;
                }

                .field-hint {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-top: 10px;
                    font-size: 13px;
                    color: #6c757d;

                    .material-icons {
                        font-size: 16px;
                    }
                }
            }
        }

        .preview-section {
            padding-top: 24px;
            border-top: 2px solid #e8eaed;

            .preview-header {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 16px;

                .material-icons {
                    font-size: 22px;
                    color: #22272d;
                }

                span {
                    font-size: 15px;
                    font-weight: 700;
                    color: #22272d;
                    letter-spacing: 0.3px;
                }
            }

            .owner-card {
                display: flex;
                align-items: center;
                gap: 18px;
                padding: 20px;
                background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                border: 2px solid #e8eaed;
                border-radius: 14px;
                transition: all 0.3s ease;

                &:hover {
                    border-color: #22272d;
                    box-shadow: 0 4px 12px rgba(34, 39, 45, 0.08);
                }

                .owner-avatar {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 56px;
                    height: 56px;
                    background: linear-gradient(135deg, #22272d 0%, #3d4451 100%);
                    border-radius: 50%;
                    flex-shrink: 0;
                    box-shadow: 0 4px 12px rgba(34, 39, 45, 0.2);

                    .material-icons {
                        font-size: 28px;
                        color: white;
                    }
                }

                .owner-details {
                    flex: 1;

                    .owner-name {
                        font-size: 16px;
                        font-weight: 700;
                        color: #22272d;
                        margin-bottom: 4px;
                    }

                    .owner-role {
                        font-size: 13px;
                        color: #6c757d;
                        font-weight: 500;
                    }
                }

                .owner-badge {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 36px;
                    height: 36px;
                    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
                    border-radius: 50%;

                    .material-icons {
                        font-size: 20px;
                        color: white;
                    }
                }
            }
        }

        .modal-footer {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 12px;
            padding: 20px 28px;
            border-top: 2px solid #e8eaed;

            .supsis-button {
                height: 44px;
                padding: 0 24px;
                font-size: 15px;
                border-radius: 10px;

                .material-icons {
                    font-size: 18px;
                }
            }
        }
    }
}
</style>
